import { render, staticRenderFns } from "./CentroCostoComponent.vue?vue&type=template&id=215c357f&"
import script from "./CentroCostoComponent.vue?vue&type=script&lang=js&"
export * from "./CentroCostoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports